import { AnyAction } from 'redux';
import {
  AuthState,
  GET_USER_INFO_SUCCESS,
  LOGOUT_SUCCESS,
  VERIFY_LOGIN_OTP_SUCCESS,
} from '../types/auth';
import { VERIFY_OTP_INVESTOR_SUCCESS } from '../types/onBoarding';

const initState: Partial<AuthState> = {
  token: null,
};
function authReducer(state = initState, action: AnyAction): Partial<AuthState> {
  switch (action.type) {
    case VERIFY_LOGIN_OTP_SUCCESS:
    case GET_USER_INFO_SUCCESS: {
      console.log('auth', action.body);
      return {
        ...state,
        ...action.body,
      };
    }
    case LOGOUT_SUCCESS: {
      return { ...initState };
    }
    default:
      return state;
  }
}

export default authReducer;
